import React from 'react';

interface CardContainerProps {
  children: React.ReactNode;
  showBorder?: boolean;
  noAnyBorder?: boolean;
  className?: string;
}

// Function to render the inner content with gradient background
const renderContent = (children: React.ReactNode) => (
  <div className="rounded-lg h-full w-full">
    <div className="bg-[#383A3C] rounded-md p-1 h-full w-full">
      <div className="bg-[#191A1B] rounded-md h-full w-full">
        <div
          className="h-full w-full"
          style={{
            background: 'linear-gradient(#191A1B, #1E2021)',
            boxShadow: 'inset 2px 2px 12px rgba(0, 0, 0, 1)',
          }}
        >
          <div className="h-full w-full">{children}</div>
        </div>
      </div>
    </div>
  </div>
);

const renderNoBorderContent = (children: React.ReactNode) => (
  <div
    className="h-full w-full"
    style={{
      background: 'linear-gradient(#191A1B, #1E2021)',
      boxShadow: 'inset 2px 2px 12px rgba(0, 0, 0, 1)',
    }}
  >
    <div className="h-full w-full">{children}</div>
  </div>
);

const CardContainer: React.FC<CardContainerProps> = ({ children, showBorder = true, noAnyBorder = false, className }) => {
  if (showBorder) {
    return <div className={`${className || ''} flex flex-col bg-[#191A1B] rounded-lg p-1`}>{renderContent(children)}</div>;
  }

  if (noAnyBorder) {
    return <div className={`${className || ''} flex flex-col`}>{renderNoBorderContent(children)}</div>;
  }

  return <div className={className || ''}>{renderContent(children)}</div>;
};

export default CardContainer;
